import { getDefaultStore } from 'jotai';
import { csrfTokenAtom } from '@/store/authAtoms';

const store = getDefaultStore();
const CSRF_COOKIE = 'XSRF-ADMIN-TOKEN';

function readCsrfCookie(): string | undefined {
  const match = document.cookie
    .split(';')
    .map((c) => c.trim())
    .find((c) => c.startsWith(`${CSRF_COOKIE}=`));
  if (!match) return undefined;
  const value = decodeURIComponent(match.slice(CSRF_COOKIE.length + 1));
  return value || undefined;
}

export function getCsrfToken(): string | undefined {
  // Prefer the in-memory atom (set on login). Fall back to the JS-readable
  // XSRF-ADMIN-TOKEN cookie so the token survives a page refresh without
  // requiring the user to log in again.
  return store.get(csrfTokenAtom) ?? readCsrfCookie();
}

export function setCsrfToken(token: string | null): void {
  store.set(csrfTokenAtom, token);
}
